import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";

import PrivateRoute from "./components/PrivateRoute";
import Layout from "./pages/Layout";

import Analitico from "./pages/Analitico";
import Educacional from "./pages/Educacional";
import Home from "./pages/Home";
import Investimento from "./pages/Investimentos";
import Lacamentos from "./pages/Lacamentos"; // Corrija o nome se for "Lancamentos"
import Login from "./pages/Login";
import Logout from "./pages/logout"; // ← CORRIGIDO (minúsculo)
import OrcParam from "./pages/OrcParam";
import ReceitaDiversas from "./pages/ReceitaDiversas";
import RecursosHumano from "./pages/RecursosHumanos";
import Redutor from "./pages/Redutor";
import ReportsHumano from "./pages/ReportsHumano";
import Sinteico from "./pages/Sinteico";
import Tranferencia from "./pages/Transferencia";

import Kanbam from "./pages/Kanbam";
import MaquinaRateio from "./pages/MaquinaRateio";
import NaoConformidade from "./pages/NaoConformidade";
import Procon from "./pages/Procon";
import Compras from "./pages/TelaCompras";
import Eletivas from "./pages/Eletivas";
import Intercompany from "./pages/Op.Intercompany";
import Repasse from "./pages/Repasse";
import Relatorios from "./pages/Relatorio";


export default function App() {
  return (
    <Router basename="/orcamento">
      <Routes >
        {/* Redirecionamento inicial */}
        <Route path="/" element={<Navigate to="/login" />} />
        {/* Rotas públicas */}
        <Route path="/login" element={<Login />} />
        <Route path="/logout" element={<Logout />} />{" "}
        {/* ← Logout fora do Layout */}
        {/* Rotas privadas com layout fixo (Sidebar + Conteúdo) */}
        <Route
          element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }
        >
          <Route path="/home" element={<Home />} />
          <Route path="/parametro" element={<OrcParam />} />
          <Route path="/lancamentos/despesas-gerais" element={<Lacamentos />} />
          <Route path="/lancamentos/receitas-Redutor" element={<Redutor />} />
          <Route path="/lancamentos/Kanbam" element={<Kanbam />} />
          <Route path="/lancamentos/Compras" element={<Compras />} />
          <Route path="/lancamentos/Procon" element={<Procon />} />
          <Route path="/lancamentos/Eletivas" element={<Eletivas />} />
          <Route path="/lancamentos/Intercompany" element={<Intercompany />} />
          <Route path="/lancamentos/Repasse" element={<Repasse />} />
          <Route path="/lancamentos/Relatorios" element={<Relatorios />} />

          <Route
            path="/lancamentos/NaoConformidade"
            element={<NaoConformidade />}
          />

          <Route
            path="/lancamentos/MaquinaRateio"
            element={<MaquinaRateio />}
          />

          <Route
            path="/lancamentos/receitas-diversas"
            element={<ReceitaDiversas />}
          />

          <Route
            path="/lancamentos/despesas-Investimento"
            element={<Investimento />}
          />

          <Route
            path="/lancamentos/rec-educacional"
            element={<Educacional />}
          />
          <Route
            path="/lancamentos/rec-RecursosHumano"
            element={<RecursosHumano />}
          />
          <Route
            path="/lancamentos/rec-transferencia"
            element={<Tranferencia />}
          />

          <Route path="/lancamentos/rel-sinteico" element={<Sinteico />} />
          <Route path="/lancamentos/rel-Analitico" element={<Analitico />} />
          <Route
            path="/lancamentos/rel-ReportsHumano"
            element={<ReportsHumano />}
          />
        </Route>


      </Routes>
    </Router>
  );
}
